import { appStore, businessStore, userStore, walletStore } from '../stores';
import { apiRequest } from '../utils/useAPIRequest';
import constant from '../utils/constant';

const update = async payload => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/businesses/business/update',
		method: 'patch',
		payload,
		hasImageUpload: true,
		constantStore: [{ store: userStore.setOnBoardingDone, value: 'true' }],
	});
	if (status === constant.Success) {
		businessStore.setBusiness(data.business);
		return { status };
	}
	return { status, errorMessage };
};
const activateBvn = async token =>
	await apiRequest({
		url: `/businesses/bvn/activate/${token}`,
		method: 'get',
	});
const resendBVNCode = async () =>
	await apiRequest({
		url: '/businesses/resend-bvn-token',
		method: 'get',
	});
const signUpBusiness = async payload => {
	localStorage.clear();
	return await apiRequest({
		url: '/businesses/business',
		method: 'post',
		payload,
		constantStore: [{ store: userStore.setActivated, value: 'false' }],
		responseStore: [{ store: userStore.setUserId, value: 'userId' }],
	});
};

const businessDetails = async () => {
	const { status, errorMessage, data } = await apiRequest({
		url: '/businesses/business-details',
		method: 'get',
	});
	if (status === constant.Success) {
		businessStore.setBusiness(data);
		appStore.setGeneralSettings(data.settings);
		return { status };
	}
	return { status, errorMessage };
};

const generateBankAccount = async () => {
	const { status, errorMessage } = await apiRequest({
		url: '/businesses/generate-business-bank-account',
		method: 'get',
	});
	if (status === constant.Success) {
		walletStore.setCreatingAccNo(true);
		businessDetails();
		return { status: constant.Success };
	}
	return { errorMessage, status };
};

const getBusinessReportByDate = async payload => {
	const query = `startDate=${payload.startDate}&endDate=${payload.endDate}`;

	const { status, errorMessage } = await apiRequest({
		url: `/businesses/business-report-by-dates?${query}`,
		method: 'get',
	});

	if (status === constant.Success) {
		return { status: constant.Success };
	}
	return { errorMessage, status };
};

const getBusinessReportAsPdf = async payload => {
	const query = `startDate=${payload.startDate}&endDate=${payload.endDate}`;

	const { status, errorMessage } = await apiRequest({
		url: `/businesses/business-report-pdf?${query}`,
		method: 'get',
	});

	if (status === constant.Success) {
		return { status: constant.Success };
	}
	return { errorMessage, status };
};

const sendToken = async payload => {
	const { status, errorMessage } = await apiRequest({
		url: '/businesses/validate-business-mobile',
		method: 'patch',
		payload,
	});

	if (status === constant.Success) {
		return { status: constant.Success };
	}
	return { errorMessage, status };
};

const verifyToken = async query => {
	const { status, errorMessage } = await apiRequest({
		url: `/businesses/verify-mobile-token?${query}`,
		method: 'get',
	});

	if (status === constant.Success) {
		businessDetails();
		return { status: constant.Success };
	}
	return { errorMessage, status };
};

const BusinessController = {
	signUpBusiness,
	update,
	resendBVNCode,
	activateBvn,
	businessDetails,
	generateBankAccount,
	getBusinessReportByDate,
	getBusinessReportAsPdf,
	sendToken,
	verifyToken,
};

export default BusinessController;
